'use client';

import { useEffect } from 'react';

import { type FlowExecutionContextProp } from './contexts/flowContext';
import { useFlowCurrentStepUrl } from './hooks/useFlowCurrentStepUrl';

export const FlowUrlUpdater = ({ context }: FlowExecutionContextProp) => {
  const currentStepUrl = useFlowCurrentStepUrl();

  useEffect(() => {
    const currentUrl = new URL(currentStepUrl);
    const actualUrl = new URL(window.location.href);

    const desiredUrl = new URL(window.location.href);
    desiredUrl.pathname = currentUrl.pathname;
    desiredUrl.searchParams.delete('navigate');

    const actualUrlString = actualUrl.toString();
    const desiredUrlString = desiredUrl.toString();

    if (actualUrlString !== desiredUrlString) {
      window.history.replaceState({}, '', desiredUrlString);
    }
  }, [context, currentStepUrl]);

  return null;
};
